const getInitialValue = (initialValues, field) => {
  const isAlreadySet = Object.keys(initialValues).includes(field.name)
  const value = isAlreadySet ? initialValues[field.name] : field.value
  return value || ''
}

export default getInitialValue
